import * as actions from '../../actions/actionTypes';
//
const initialState = 0;
//
export default function chId(state = initialState, action) {
  switch (action.type) {
    //
    case actions.SET_CHANNEL_CHANNEL_PARAM:
      if (typeof action.payload.chId !== 'undefined') {
        return action.payload.chId;
      } else {
        return state;
      }
    default:
      return state;
  }
}
